import img_day from "../../assets/roadworkers_day.png"
import img_night from "../../assets/roadworkers_night.png"
import styles from "./Home.module.css"

function ImageCard({ src, title, description }) {
    return (
      <div className={styles.imageCard}>
        <div className={styles.imageWrapper}>
          <img 
            alt={title} 
            className={styles.imagePhoto}
            src={src} 
          />
          <div className={styles.imageOverlay} />
          <div className={styles.imageCaption}>
            <p className={styles.captionTitle}>{title}</p>
            <p className={styles.captionText}>{description}</p>
          </div>
        </div>
      </div>
    );
  }
  
  export default function OurMissionSection() {
    return (
      <div className={styles.ourMissionSection}>
        <div className={styles.missionHeader}>
          <h2 className={styles.missionTitle}>Our Mission</h2>
          <p className={styles.missionDescription}>
            The Mississippi Roadworker's Foundation is committed to supporting the safety, welfare, and professional development of road construction workers throughout the state.
          </p>
        </div>
        
        <div className={styles.imagesGrid}>
          <ImageCard 
            src={img_day}
            title="Teamwork in Action"
            description="Mississippi roadworkers collaborating on infrastructure projects"
          />
          <ImageCard 
            src={img_night}
            title="24/7 Dedication"
            description="Working around the clock to keep our roads safe"
          />
        </div>
      </div>
    );
  }
